<template>
  <v-card class="pa-3">
    <h3>
      {{ $t('title.ticket_manage') }}
    </h3>
    <v-switch
      v-model="manageBankingTickets"
      :label="$t('field.settings.manage_tickets')"
      color="accent"
      class="my-3"
      hide-details
    />
    <v-switch
      v-model="printCustomerTicket"
      :disabled="!manageBankingTickets"
      :label="$t('field.settings.print_client_ticket')"
      color="accent"
      class="mt-0"
      hide-details
    />
    <v-switch
      v-model="printMerchantTicket"
      :disabled="!manageBankingTickets"
      :label="$t('field.settings.print_merchant_ticket')"
      color="accent"
      class="mt-0"
      hide-details
    />
  </v-card>
</template>

<script>
export default {
  name: 'ManageTickets',

  computed: {
    manageBankingTickets: {
      get() {
        return this.$store.state.manageBankingTickets
      },
      set(val) {
        this.$store.commit('manageBankingTickets', val)
        localStorage.setItem('manageBankingTickets', val)
        // CissAndroid.setPrinterCapability(val)
        if (!val) {
          this.$store.commit('printCustomerTicket', false)
          this.$store.commit('printMerchantTicket', false)
          localStorage.setItem('printCustomerTicket', false)
          localStorage.setItem('printMerchantTicket', false)
        }
      }
    },
    printCustomerTicket: {
      get() {
        return this.$store.state.printCustomerTicket
      },
      set(val) {
        this.$store.commit('printCustomerTicket', val)
        localStorage.setItem('printCustomerTicket', val)
      }
    },
    printMerchantTicket: {
      get() {
        return this.$store.state.printMerchantTicket
      },
      set(val) {
        this.$store.commit('printMerchantTicket', val)
        localStorage.setItem('printMerchantTicket', val)
      }
    }
  }
}
</script>
